<app-plan-details *ngIf="vendorRequest" [form]="form" [plan]="vendorRequest?.planData ?? plan" (onSubmit)="updateRegistration()" [submitting]="submitting"></app-plan-details>
